import {
    COMPONENT_CARD_HEIGHT,
    COMPONENT_CARD_PADDING,
    COMPONENT_CARD_WIDTH_CATALOGUE,
    SMALL_COMPONENT_CARD_HEIGHT,
    SMALL_COMPONENT_CARD_WIDTH
} from "./specs";

type Options = {
    smallSize: boolean;
};

function getComponentImageWidth(imageWidth: number, imageHeight: number) {
    const imageMaxHeight = COMPONENT_CARD_HEIGHT - 2 * COMPONENT_CARD_PADDING;
    const calculatedWidth = (imageWidth * Math.min(imageMaxHeight, imageHeight)) / imageHeight;

    return Math.min(
        calculatedWidth,
        COMPONENT_CARD_WIDTH_CATALOGUE[COMPONENT_CARD_WIDTH_CATALOGUE.length - 1] - 2 * COMPONENT_CARD_PADDING
    );
}

function getComponentImageHeight(options: Options = { smallSize: false }) {
    if (options.smallSize) {
        return SMALL_COMPONENT_CARD_HEIGHT;
    }

    return COMPONENT_CARD_HEIGHT;
}

function getComponentCardWidth(
    imageWidth: number,
    imageHeight: number,
    options: Options = { smallSize: false }
) {
    if (options.smallSize) {
        return SMALL_COMPONENT_CARD_WIDTH;
    }

    const calculatedImageWidth = getComponentImageWidth(imageWidth, imageHeight);

    return (
        COMPONENT_CARD_WIDTH_CATALOGUE.find(
            cardWidth => calculatedImageWidth <= cardWidth - 2 * COMPONENT_CARD_PADDING
        ) || COMPONENT_CARD_WIDTH_CATALOGUE[COMPONENT_CARD_WIDTH_CATALOGUE.length - 1]
    );
}

function getComponentCardImageDimensions(
    imageWidth: number,
    imageHeight: number,
    options: Options = { smallSize: false }
) {
    if (options.smallSize) {
        return {
            width: imageWidth,
            height: imageHeight
        };
    }

    const maxWidth =
        COMPONENT_CARD_WIDTH_CATALOGUE[COMPONENT_CARD_WIDTH_CATALOGUE.length - 1] - 2 * COMPONENT_CARD_PADDING;
    const maxHeight = COMPONENT_CARD_HEIGHT - 2 * COMPONENT_CARD_PADDING;

    const maxDimensionsAspectRatio = maxWidth / maxHeight;
    const aspectRatio = imageWidth / imageHeight;

    if (imageHeight > maxHeight && imageWidth > maxWidth) {
        if (maxDimensionsAspectRatio > aspectRatio) {
            return {
                height: maxHeight,
                aspectRatio: `${aspectRatio}`,
                width: "unset"
            };
        }

        return {
            width: maxWidth,
            aspectRatio: `${aspectRatio}`
        };
    }

    if (imageHeight > maxHeight) {
        return {
            height: maxHeight,
            aspectRatio: `${aspectRatio}`,
            width: "unset"
        };
    }

    if (imageWidth > maxWidth) {
        return {
            width: maxWidth,
            aspectRatio: `${aspectRatio}`
        };
    }

    const calculatedWidth = getComponentImageWidth(imageWidth, imageHeight);

    return {
        aspectRatio: `${aspectRatio}`,
        width: calculatedWidth,
        minWidth: calculatedWidth,
        maxHeight: COMPONENT_CARD_HEIGHT - 2 * COMPONENT_CARD_PADDING
    };
}

export { getComponentCardWidth, getComponentImageHeight, getComponentCardImageDimensions };
